// -----------------------------------------------------------------------------
// <copyright file="currency.pipe.ts" company="ecoInsight, Inc.">
// Copyright © ecoInsight, Inc. All rights reserved.
// </copyright>
// ------------------------------------------------------------------------------

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'currency',
    standalone: false
})
export class CurrencyPipe implements PipeTransform {
	transform(value: string): any {
		if (!value) {
			return value;
		}
		let val;
		if (value.indexOf('#$#') > -1) {
			val = value.replace('#$#', '$');
			return val;
		} else {
			return value;
		}
	}
}
